import SignInCentered from 'views/auth/signIn';
import AddPosView from 'views/admin/add_pos';
import HomeView from 'views/admin/home';
import WalletView from 'views/admin/wallet';
import DevelopersView from 'views/admin/developers';
import WoocommerceView from 'views/admin/woocommerce';

const routes = [
	{
		name: 'Points of Sale',
		nameKey: 'menu.startHere',
		layout: '/admin',
		path: '/pos',
		component: AddPosView,
		needsAuth: false,
		fullscreen: true,
	},
	{
		name: 'Settings',
		nameKey: 'menu.getPaid',
		layout: '/admin',
		path: '/settings',
		component: WalletView,
		needsAuth: true,
		fullscreen: true,
	},
	{
		name: 'Dashboard',
		nameKey: 'menu.notifications',
		layout: '/admin',
		path: '/dashboard',
		component: HomeView,
		needsAuth: true,
		fullscreen: true,
	},
	{
		name: 'Developers',
		layout: '/admin',
		path: '/developers',
		component: DevelopersView,
		needsAuth: true,
		fullscreen: true,
	},
	{
		name: 'Woocommerce',
		layout: '/admin',
		path: '/woocommerce',
		component: WoocommerceView,
		needsAuth: true,
		fullscreen: true,
	},
	{
		name: 'Sign In',
		nameKey: 'auth.signIn',
		layout: '/auth',
		path: '/sign-in',
		component: SignInCentered,
		needsAuth: false,
	},
];

export default routes;
